import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, Building2 } from "lucide-react";

const tono = (p) =>
  p >= 95 ? { bar: "bg-blue-600", txt: "text-blue-700", soft: "bg-blue-50" }
  : p >= 75 ? { bar: "bg-emerald-500", txt: "text-emerald-700", soft: "bg-emerald-50" }
  : p >= 40 ? { bar: "bg-amber-500", txt: "text-amber-700", soft: "bg-amber-50" }
  : { bar: "bg-rose-500", txt: "text-rose-700", soft: "bg-rose-50" };

const Barra = ({ pct }) => (
  <div className="h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
    <div className={`h-full rounded-full ${tono(pct).bar}`} style={{ width: `${Math.min(100, pct)}%` }} />
  </div>
);

const redondo = (n) => Math.round(Number(n ?? 0));

/** Ocupación de los grupos regulares: general y por oficina. */
export const GroupsCapacityCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let vivo = true;
    api.get("/groups/capacity")
      .then((r) => { if (vivo) setData(r.data); })
      .catch(() => { if (vivo) setData({ error: true }); });
    return () => { vivo = false; };
  }, []);

  if (!data || data.error || !data.seats) {
    return (
      <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid="kpi-capacity">
        <div className="text-[13px] text-slate-500 font-medium">Capacidad de grupos</div>
        <div className="text-xs text-slate-400 mt-2">
          {data ? "Sin grupos con cupo definido" : "Cargando…"}
        </div>
      </div>
    );
  }

  const pct = redondo(data.pct);
  const c = tono(pct);
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid="kpi-capacity">
      <div className="grid grid-cols-1 sm:grid-cols-[196px_1fr] gap-4">
        <div className="sm:border-r sm:border-slate-100 sm:pr-4">
          <div className="flex items-center gap-2">
            <span className={`h-6 w-6 rounded-lg grid place-items-center shrink-0 ${c.soft} ${c.txt}`}>
              <Users className="h-3.5 w-3.5" />
            </span>
            <div className="text-[12px] text-slate-500 font-medium whitespace-nowrap">Capacidad de grupos</div>
          </div>
          <div className="mt-1.5 flex items-end gap-2">
            <div className={`font-display text-[34px] font-extrabold leading-none tabular-nums ${c.txt}`}
                 data-testid="capacity-total-pct">
              {pct}<span className="text-lg text-slate-400">%</span>
            </div>
            <div className="pb-0.5 text-[11.5px] text-slate-500 leading-tight">
              {data.occupied} de {data.seats}<br />cupos ocupados
            </div>
          </div>
          <div className="mt-2"><Barra pct={pct} /></div>
          <div className="text-[11px] text-slate-400 mt-1.5">
            {data.groups} {data.groups === 1 ? "grupo abierto" : "grupos abiertos"} · {data.free} libres
            {data.full_groups > 0 && ` · ${data.full_groups} ${data.full_groups === 1 ? "lleno" : "llenos"}`}
          </div>
        </div>
        <div className="space-y-2">
          <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400 flex items-center gap-1.5">
            <Building2 className="h-3 w-3" /> Por oficina
          </div>
          <div className="space-y-2 max-h-[150px] overflow-y-auto pr-1">
            {data.by_sede.map((o) => {
            const p = redondo(o.pct);
            return (
              <div key={o.sede_id} className="grid grid-cols-[88px_1fr_74px] items-center gap-2"
                   data-testid={`capacity-sede-${o.sede_id}`}>
                <div className="text-[12px] text-slate-700 font-medium truncate" title={o.name}>{o.name}</div>
                <Barra pct={p} />
                <div className="text-[11px] tabular-nums text-right">
                  <span className={`font-bold ${tono(p).txt}`}>{p}%</span>
                  <span className="text-slate-400"> · {o.occupied}/{o.seats}</span>
                </div>
              </div>
            );
          })}
          </div>
        </div>
      </div>
    </div>
  );
};
